import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Text, { TextTypes } from '../../Text';

import Logo from '../../Logo';

import Image from './Image';

const Reference = ({ styles, content, rules }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Text extend={rules.extendRefferenceText} type={TextTypes.NORMAL}>
                    <FormattedMessage id={content.content} />
                </Text>
            </div>

            {content.isAckee && <Logo extend={{ container: rules.logoContainer, logo: rules.logo }} />}
            <Image authorName={content.authorName} src={content.authorImage} />
            <div className={styles.authorContainer}>
                <Text extend={rules.extendText} type={TextTypes.NORMAL}>
                    <FormattedMessage values={{ empty: ' ' }} id={content.authorName} />
                </Text>
                <Text extend={rules.extendPositionText} type={TextTypes.NORMAL}>
                    <FormattedMessage id={content.authorPosition} values={{ empty: ' ' }} />
                </Text>
            </div>
        </div>
    );
};

Reference.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    content: PropTypes.shape().isRequired,
};

export default Reference;
